export const FEATURES = {
    promos: false,
} as const;
